import React, { Component } from 'react';
import Wave from '../../Components/Wave'
import './Section.scss'
import Circle from './Circle'
import { Link } from 'react-router-dom'

class Section extends Component {
	render() {
		return (
			<div>
				<div id={this.props.home} className={`home-section ${this.props.theme}`}>
					{this.props.top && <Wave className={`top ${this.props.theme}`} />}
					{this.props.bottom && <Wave className={`bottom ${this.props.theme}`} />}
					<div className="container-fluid">
						<div className="row align-items-center">
							
							<div className="col-lg-4 text-center">
								<Link to={this.props.to || "/"}>
									<Circle image={this.props.image} id={this.props.id} {...this.props.circle} />
								</Link>
							</div>
							<div className="col-lg-7">
								<h2>
									<span>{this.props.titleLine1}</span>
									<div>{this.props.titleLine2}</div>
								</h2>
								<p>
									{this.props.desc}
								</p>
								<ul>
									{this.props.list && this.props.list.map(item => <li key={item}>
										<Link to={"/what-we-do"}>{item}</Link>
									</li>)}
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}


export default Section;


// WEBPACK FOOTER //
// ./src/Pages/Home/Section.js